import React from 'react'

const CommunityHeaderIcon = ({ className, size = 32 }) => {
  return (
    <svg 
      className={className}
      width={size} 
      height={size} 
      viewBox="0 0 32 32" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="community-grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(233, 30, 99, 1)" />
          <stop offset="100%" stopColor="rgba(194, 24, 91, 1)" />
        </linearGradient>
        <filter id="community-glow">
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Central person */}
      <circle cx="16" cy="10" r="3.5" stroke="url(#community-grad)" strokeWidth="2" filter="url(#community-glow)"/>
      <path 
        d="M10 24C10 20 12.5 18 16 18C19.5 18 22 20 22 24" 
        stroke="url(#community-grad)" 
        strokeWidth="2" 
        strokeLinecap="round"
        filter="url(#community-glow)"
      />
      
      {/* Left person */}
      <circle cx="7" cy="12" r="2.5" stroke="url(#community-grad)" strokeWidth="1.8" opacity="0.7"/>
      <path 
        d="M3 22C3 19.5 4.5 18 7 18C8.5 18 9.5 18.5 10 19.5" 
        stroke="url(#community-grad)" 
        strokeWidth="1.8" 
        strokeLinecap="round"
        opacity="0.7"
      />
      
      {/* Right person */}
      <circle cx="25" cy="12" r="2.5" stroke="url(#community-grad)" strokeWidth="1.8" opacity="0.7"/>
      <path 
        d="M29 22C29 19.5 27.5 18 25 18C23.5 18 22.5 18.5 22 19.5" 
        stroke="url(#community-grad)" 
        strokeWidth="1.8" 
        strokeLinecap="round"
        opacity="0.7"
      />
      
      {/* Connection heart */}
      <path 
        d="M16 14C16 14 14.5 12.5 13 12.5C11.5 12.5 10.5 13.5 10.5 15C10.5 17 16 20 16 20C16 20 21.5 17 21.5 15C21.5 13.5 20.5 12.5 19 12.5C17.5 12.5 16 14 16 14Z" 
        fill="url(#community-grad)" 
        opacity="0.3"
      />
      
      {/* Unity circles */}
      <circle cx="16" cy="28" r="1.5" fill="url(#community-grad)" opacity="0.8"/>
      <circle cx="10" cy="26" r="1" fill="url(#community-grad)" opacity="0.6"/>
      <circle cx="22" cy="26" r="1" fill="url(#community-grad)" opacity="0.6"/>
      
      {/* Stars around */}
      <path d="M4 6L4.5 7.5L6 8L4.5 8.5L4 10L3.5 8.5L2 8L3.5 7.5L4 6Z" fill="url(#community-grad)" opacity="0.6"/>
      <path d="M28 6L28.5 7.5L30 8L28.5 8.5L28 10L27.5 8.5L26 8L27.5 7.5L28 6Z" fill="url(#community-grad)" opacity="0.6"/>
    </svg>
  )
}

export default CommunityHeaderIcon
